/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': 'Be ditt team eller din administratör om hjälp.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': 'Det gick inte att hämta några resultat för sökningen'
};